var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('h1',{},[_vm._v(_vm._s(_vm.title))]),_c('small',{staticClass:"lead"},[_vm._v(_vm._s(_vm.description))]),_c('hr',{staticClass:"my-4"})])}
var staticRenderFns = []

export { render, staticRenderFns }